module.exports = __webpack_public_path__ + "static/media/product-team.0d2a8ce5.svg";